import { SystemPageKey } from '@internal/page/SystemPageKey';
import { TLocale } from '@internal/utils/machine/i18n/TLocale';
import { ImageLoader } from '@internal/utils/media/ImageLoader';
import { RolloutsContext } from '@internal/utils/rollouts/RolloutsContext';
import { urlForSystemPageWithoutParams } from '@internal/utils/routing/urls/urlForSystemPageWithoutParams';
import { Grid, Stack } from '@mui/material';
import Logo from '@renderer-ui-library/assets/logo.svg';
import Breakpoints from '@renderer-ui-library/mui/base/breakpoints.module.scss';
import Image from 'next/image';
import React, { memo, useContext, useMemo } from 'react';
import { HeaderLocales } from '../../HeaderLocales/HeaderLocales';
import { SearchAutosuggest } from '../../SearchBar/SearchAutosuggest/SearchAutosuggest';
import { DynamicSearchOverlay } from '../../SearchOverlay/dymanicSearchOverlay';
import styles from './desktopSearchBar.module.scss';

export const portalSlotDesktopId = 'navigation-portal-slot-desktop';

export const DesktopSearchBar: React.FC<{
    locale: TLocale;
    isOnSerp: boolean;
}> = memo(({ locale, isOnSerp }) => {
    const { newSearch } = useContext(RolloutsContext);
    const startPageUrl = useMemo(
        () => urlForSystemPageWithoutParams(locale, SystemPageKey.StartPage),
        [locale],
    );

    return (
        <div className={styles.desktopSearchBar}>
            <Grid
                container
                spacing={0}
                alignItems="center"
                maxWidth={parseInt(Breakpoints.lg)}
                className={styles.container}
            >
                <Grid item md={3}>
                    <div style={{ display: 'flex' }}>
                        <a href={startPageUrl} className={styles.logo}>
                            <Image
                                loading="lazy"
                                src={Logo.src}
                                alt="E-FARM GmbH"
                                loader={ImageLoader}
                                fill
                            />
                        </a>
                    </div>
                </Grid>
                <Grid
                    item
                    md={6}
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-end"
                >
                    <div id={portalSlotDesktopId} />
                    {newSearch && (
                        <SearchAutosuggest
                            locale={locale}
                            isOnSerp={isOnSerp}
                        />
                    )}
                </Grid>
                <Grid item md={3} className={styles.localesWrapper}>
                    <Stack direction="row" spacing={4} alignItems="center">
                        {!newSearch && <DynamicSearchOverlay />}
                        <HeaderLocales
                            locale={locale}
                            className={styles.locales}
                        />
                    </Stack>
                </Grid>
            </Grid>
        </div>
    );
});

DesktopSearchBar.displayName = 'DesktopSearchBar';
